import { Skeleton } from '@heidi/design-system/skeleton';

export const EvidencePostUpgradeOnboardingModalLoading = () => (
  <div
    className="flex w-full max-w-[406px] flex-col gap-6"
    data-testid="evidence-post-upgrade-onboarding-modal-loading"
  >
    <Skeleton className="aspect-[406/225] w-full rounded-lg" />
    <div className="flex flex-col gap-3">
      <Skeleton className="mx-auto h-8 w-4/5" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-11/12" />
    </div>
    <Skeleton className="h-12 w-full rounded-lg" />
    <Skeleton className="h-12 w-full rounded-lg" />
  </div>
);
